export const QUOTA_RESTRICTION_TYPE = {
  RESTRICTED: "restricted",
  UNRESTRICTED: "unrestricted",
} as const;

export const QUOTA_TYPES = {
  CAMPAIGN_IMPRESSIONS: "CAMPAIGN_IMPRESSIONS",
  CAMPAIGN_IMPRESSIONS_ALLOCATION: "CAMPAIGN_IMPRESSIONS_ALLOCATION",
  LINKEDIN_PROFILES_RESOLVED: "LINKEDIN_PROFILES_RESOLVED",
  ADVERTISERS: "ADVERTISERS",
} as const;
